import { Link } from "react-router-dom";
import { GraduationCap, MapPin, Mail, Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-[#0B2A6B] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-1">
          <Link to="/" className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-white/10">
              <GraduationCap className="h-5 w-5 text-[#D4A24C]" />
            </span>
            <span className="font-display text-lg font-extrabold tracking-tight">
              College<span className="text-[#D4A24C]">Unlock</span>
            </span>
          </Link>
          <p className="mt-4 text-sm text-white/70 leading-relaxed">
            Unlock the right college with AI-powered admission guidance. India's smartest college decision platform.
          </p>
        </div>

        <div>
          <h4 className="font-display text-sm font-bold uppercase tracking-wider text-[#D4A24C]">Explore</h4>
          <ul className="mt-4 space-y-2 text-sm text-white/80">
            <li><Link to="/colleges" className="hover:text-white">Browse Colleges</Link></li>
            <li><Link to="/compare" className="hover:text-white">Compare Colleges</Link></li>
            <li><Link to="/ai-counseling" className="hover:text-white">AI Counseling</Link></li>
            <li><Link to="/expert-counseling" className="hover:text-white">Expert Counseling</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display text-sm font-bold uppercase tracking-wider text-[#D4A24C]">Company</h4>
          <ul className="mt-4 space-y-2 text-sm text-white/80">
            <li><Link to="/contact" className="hover:text-white">Contact Us</Link></li>
            <li><Link to="/ai-counseling" className="hover:text-white">Admission Sarthi</Link></li>
            <li><Link to="/admin/login" className="hover:text-white">Admin Login</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-display text-sm font-bold uppercase tracking-wider text-[#D4A24C]">Get in touch</h4>
          <ul className="mt-4 space-y-3 text-sm text-white/80">
            <li className="flex items-center gap-2"><MapPin className="h-4 w-4 text-[#D4A24C]" /> India</li>
            <li className="flex items-center gap-2"><Mail className="h-4 w-4 text-[#D4A24C]" /> hello@collegeunlock.in</li>
            <li className="flex items-center gap-2"><Phone className="h-4 w-4 text-[#D4A24C]" /> +91 83789 48584</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 space-y-2 text-center text-xs text-white/60">
          <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1">
            <Link to="/about" className="hover:text-white">About</Link>
            <Link to="/privacy" className="hover:text-white">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-white">Terms &amp; Conditions</Link>
            <Link to="/refund" className="hover:text-white">Refund Policy</Link>
            <Link to="/contact" className="hover:text-white">Contact</Link>
          </div>
          <p>© {new Date().getFullYear()} CollegeUnlock. All rights reserved. · Admission Sarthi — Your AI Admission Counselor.</p>
          <p data-testid="footer-legal-owner">College Unlock® is owned and operated by Spiritual Mantra.</p>
        </div>
      </div>
    </footer>
  );
}
